import {
  Popover,
  PopoverTrigger,
  Button,
  PopoverContent,
} from "@heroui/react";

import { memo, useState } from 'react';
import isEqual from 'react-fast-compare';

import MoveTo from './MoveTo.jsx';
import { useModal } from '@ebay/nice-modal-react';
import type { IProps } from './interface.js';
import { UseChangeIcon } from '../ChangeIcon.jsx';

const Menu = memo(
  ({
    requestClose,
    requestReorder,
    planId,
    date,
    id,
    onDateChange,
    icon,
  }: Pick<IProps, 'requestClose' | 'requestReorder'> & {
    requestMove: () => void;
    planId: string;
    date: string;
    id: string;
    onDateChange: (payload: string) => void;
    icon: string;
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const moveToModal = useModal(MoveTo);
    const changeIconModal = UseChangeIcon();

    return (
      <Popover
        // @ts-ignore type
        color={'foreground'}
        placement='top'
        backdrop='opaque'
        classNames={{ backdrop: '!opacity-10' }}
        shouldCloseOnBlur
        isOpen={isOpen}
        onOpenChange={(open: boolean) => setIsOpen(open)}
      >
        <PopoverTrigger>
          <Button color={'foreground'} className='px-0 min-w-0'>
            <i className='ic-round md-more_horiz text-gray-500/60 text-2xl' />
          </Button>
        </PopoverTrigger>
        <PopoverContent className='bg-transparent shadow-none'>
          <div className='text-base text-gray-800 font-[500]  pl-2  '>
            <div
              className='bg-white shadow-45 rounded-full px-5 py-3.5 w-44 flex items-center justify-between mb-2'
              onClick={() => {
                setIsOpen(false);
                requestReorder('up');
              }}
            >
              上移
              <i className='ic-round md-keyboard_double_arrow_up text-xl' />
            </div>
            <div
              className='bg-white shadow-45 rounded-full px-5 py-3.5 w-44 flex items-center justify-between mb-2'
              onClick={() => {
                setIsOpen(false);
                requestReorder('down');
              }}
            >
              下移
              <i className='ic-round md-keyboard_double_arrow_down text-xl' />
            </div>

            <div
              className='bg-white shadow-45 rounded-full px-5 py-3.5 w-44 flex items-center justify-between mb-2'
              onClick={() => {
                setIsOpen(false);
                moveToModal.show({
                  planId,
                  defaultValue: date,
                  id,
                  onChange: onDateChange,
                });
              }}
            >
              移动至
              <i className='ic-round md-move_down text-xl' />
            </div>

            <div
              className='bg-white shadow-45 rounded-full px-5 py-3.5 w-44 flex items-center justify-between mb-2'
              onClick={() => {
                setIsOpen(false);
                changeIconModal.show({ planId, defaultValue: icon, id });
              }}
            >
              更改图标
              <i className='ic-round md-image_search text-xl' />
            </div>

            <div
              className='bg-white shadow-45 text-gray-800/30 rounded-full px-5 py-3.5 w-44 flex items-center justify-between '
              onClick={() => {
                setIsOpen(false);
                requestClose();
              }}
            >
              删除
              <i className='ic-outline md-delete text-xl' />
            </div>
          </div>
        </PopoverContent>
      </Popover>
    );
  },
  isEqual
);

export default Menu;
